import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IBranch } from 'src/app/interfaces/branch';
import { IConfirm } from 'src/app/interfaces/confirm';
import { IError } from 'src/app/interfaces/error.interface';
import { IProvince } from 'src/app/interfaces/province';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { BranchService } from 'src/app/services/http/business/branch/branch.service';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { GonbadSettingService } from 'src/app/services/http/business/gonbadSetting/gonbadSetting.service';
import { ProvinceService } from 'src/app/services/http/business/province/provinces.service';


@Component({
  selector: 'app-request-private-class',
  templateUrl: './request-private-class.component.html',
  styleUrls: ['./request-private-class.component.css']
})
export class RequestPrivateClassComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  form: FormGroup;
  provinceList: IProvince;
  branchesList: IBranch[];

  packageList = [
    { name: 'نوجوانان', value: 'نوجوانان' },
    { name: 'فرانسه عمومی', value: 'فرانسه عمومی' },
    { name: 'انگلیسی عمومی', value: 'انگلیسی عمومی' },
    { name: 'IELTS', value: 'IELTS' },
    { name: 'Free Discussion', value: 'Free Discussion' },
    { name: 'ESP', value: 'ESP' }
  ]

  dayList = [
    { name: 'شنبه', value: 'شنبه' },
    { name: 'یکشنبه', value: 'یکشنبه' },
    { name: 'دوشنبه', value: 'دوشنبه' },
    { name: 'سه شنبه', value: 'سه شنبه' },
    { name: 'چهارشنبه', value: 'چهارشنبه' },
    { name: 'پنج شنبه', value: 'پنج شنبه' },
    { name: 'جمعه', value: 'جمعه' }
  ]

  constructor(
    private fb: FormBuilder,
    private provinceService: ProvinceService,
    private branchService: BranchService,
    private snackBar: SnackBarService,
    private courseService: CourseService,
    public translate: TranslateService,
    private dialog: MatDialog,
    private gonbadSettingService: GonbadSettingService,
    private errorService: ErrorsService,
    private dialogRef: MatDialogRef<RequestPrivateClassComponent>
  ) { }

  ngOnInit() {
    this.createForm();
    this.loadProvience();
  }

  createForm() {
    this.form = this.fb.group({
      Packages: [null, Validators.compose([Validators.required])],
      IsOnline: [null, Validators.compose([Validators.required])],
      BranchEncryptId: [null],
      Days: [null, Validators.compose([Validators.required])],
      TimeStart: [null, Validators.compose([Validators.required])],
      TimeEnd: [null, Validators.compose([Validators.required])],
      SessionCount: [null, Validators.compose([Validators.required])],
    });
  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res.filter(function (e) {
        return e.Id == 1
      });
    });
  }

  getBranches(province: MatSelect) {
    this.branchService.getBranchFroPrivateCourseRequest(province.value).subscribe(
      res => {
        this.branchesList = res;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      }
    );
  }

  submit(data: any) {

    data.IsOnline = Boolean(parseInt(data.IsOnline))
    data.Days = data.Days.toString();

    this.gonbadSettingService.listGonbadSetting('ConditionsPrivateCourse').subscribe(res => {
      let confirm: IConfirm = {
        accept: true,
        message: res[0].KeyValue,
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
      this.dialog
        .open(ConfirmComponent, {
          width: "700px",
          data: confirm
        })
        .afterClosed()
        .subscribe(res => {
          if (res) {
            this.errors = new Array();
            this.courseService.SavePrivateClassRequest(data).subscribe(() => {
              this.snackBar.OpenSnackBar(
                'درخواست شما با موفقیت ارسال شد',
                "ok",
                5000,
                SoundEnum.beep
              );
              this.onNoClick();
            }, err => {
              // this.errObject = this.errorService.getError(err);
              // this.param = this.errorService.objectError(this.errObject);
              // this.errors = this.errorService.returnError(err);
              this.errorList = this.errorService.getErrorList(err.error)
            })
          }
        });
    })

  }

  onNoClick() {
    this.dialogRef.close();
  }

}
